import { APPUSER_ACCESS, APPUSER_OWN_ORDERS } from '../actions';

export function appuserAccess(state = {}, action) {
  switch (action.type) {
    case APPUSER_ACCESS:
      return action.payload;
    default:
      return state;
  }
}

export function ownOrders(state = {}, action) {
  switch (action.type) {
    case APPUSER_OWN_ORDERS:
      return action.payload;
    default:
      return state;
  }
}
